import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputText';
import InputHora from 'components/blocks/ManagementNewForms/Inputs/InputHora';
import TextAreaDefault from 'components/blocks/ManagementNewForms/TextArea/TextAreaDefault';
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';


const SolicitudVolanteAsistencia = ({ info, dataUser }: { info: boolean; dataUser: any }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const [datosAPI, setDatosAPI] = useState({ Observaciones: "Hola", FechaAceptacionSolicitud: "", RazonSocial: "COLORES AZULADOS S.L" });
    const [aceptadoFormulario, setAceptadoFormulario] = useState(true);

    const watchProvincia = watch("DatosEmpresa.EmpresaProvincia");
    const watchProvinciaDesc = watch("DatosEmpresa.EmpresaProvinciaDescripcion");
    const watchComm = watch("DatosEmpresa.EmpresaComunidadCodigo");
    const watchCommDesc = watch("DatosEmpresa.EmpresaComunidadCodigoDescripcion");

    const watchProvinciaTrabajador = watch("DatosTrabajador.TrabajadorProvincia");
    const watchProvinciaDescTrabajador = watch("DatosTrabajador.TrabajadorProvinciaDescripcion");
    const watchCommTrabajador = watch("DatosTrabajador.TrabajadorComunidadCodigo");
    const watchCommDescTrabajador = watch("DatosTrabajador.TrabajadorComunidadCodigoDescripcion");

    const watchProvinciaCentroConcertado = watch("DatosCentroConcertado.CentroConcertadoProvincia");
    const watchProvinciaDescCentroConcertado = watch("DatosCentroConcertado.CentroConcertadoProvinciaDescripcion");
    const watchCommCentroConcertado = watch("DatosCentroConcertado.CentroConcertadoComunidadCodigo");
    const watchCommDescCentroConcertado = watch("DatosCentroConcertado.CentroConcertadoComunidadCodigoDescripcion");


    const AceptarSolicitud = () => { //GESTION DE LA ACEPTACION DEL FORMULARIO
        setAceptadoFormulario(!aceptadoFormulario);
    }
    useEffect(() => {

        dataUser?.FechaAceptacionSolicitud ? setAceptadoFormulario(false) : setAceptadoFormulario(true)
        dataUser?.FechaAceptacionSolicitud ? setValue('Acepto', true) : setValue('Acepto', false)
    }, [dataUser?.FechaAceptacionSolicitud]); //Poner la fecha de aceptacion de la solicitud en el formulario















    const onSubmit = async (data: any) => {
        console.log(data);
    }




    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                {
                datosAPI?.Observaciones && <div className="card-link-block colored bright mt-5">
                    <div className="container-isextinct">
                        <h3 className="card-link_title p-1 pb-3">Observaciones del Gestor a la solicitud</h3>
                        <p className="text ">
                            {datosAPI?.Observaciones}
                        </p>
                    </div>
                </div>
                }









                {/* ////////////// COMIENZO FORMULARIO ////////////// */}






                {/* ////////////// DATOS DE LA EMPRESA ////////////// */}
                <AccordionForm title={'Datos de la Empresa'} expandedInit={false} nombreError='DatosEmpresa'>
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Datos de la Empresa" disabled={false}>
                                <FormInputText
                                    name='DatosEmpresa.EmpresaRazonSocial'
                                    id='DatosEmpresa.EmpresaRazonSocial'
                                    label='Razon Social'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                    defaultValue={datosAPI.RazonSocial}
                                />
                                <FormInputText
                                    name='DatosEmpresa.EmpresaCCC'
                                    id='DatosEmpresa.EmpresaCCC'
                                    label='Código Cuenta Cotización'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                    pattern={/^[0-9]$/}
                                    patternMessage='Solo se permiten numeros'
                                />
                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'DatosEmpresa.EmpresaProvincia'}
                                        watchProvinceDescription={watchProvinciaDesc}
                                        idDescription={'DatosEmpresa.EmpresaProvinciaDescripcion'}
                                        watchProvinceCode={watchProvincia}
                                        setValue={setValue}
                                    //disabled={datosAPI?.ProvinciaCodigo ? true : false}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvincia}
                                        watchCommunityCode={watchComm}
                                        watchCommunityDescription={watchCommDesc}
                                        idCode={'DatosPersonales.EmpresaComunidadCodigo'}
                                        idDescription={'DatosPersonales.EmpresaComunidadCodigoDescripcion'}
                                        filterByProvince={true}
                                    //disabled={datosAPI?.LocalidadCodigo ? true : false}
                                    />
                                </div>
                                <FormInputText
                                    name='DatosEmpresa.EmpresaCentroTrabajo'
                                    id='DatosEmpresa.EmpresaCentroTrabajo'
                                    label='Centro de Trabajo'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosEmpresa.EmpresaDependencias'
                                    id='DatosEmpresa.EmpresaDependencias'
                                    label='Dependencias'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>


                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <AccordionForm title={'Datos del Trabajador'} expandedInit={false} nombreError='DatosTrabajador'>
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Rogamos preste asistencia sanitaria a el/la trabajador/a de esta empresa" disabled={false}>
                                <FormInputText
                                    name='DatosTrabajador.TrabajadorNombreApellidos'
                                    id='DatosTrabajador.TrabajadorNombreApellidos'
                                    label='Nombre y Apellidos del Trabajdor'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputIPF
                                    name='DatosTrabajador.TrabajadorIPF'
                                    id={'DatosTrabajador.TrabajadorIPF'}
                                    label={'IPF (Identificación Personal Fisica)'}
                                    placeholder={''}
                                    req='El IPF es Obligatorio'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'DatosTrabajador.TrabajadorProvincia'}
                                        watchProvinceDescription={watchProvinciaDescTrabajador}
                                        idDescription={'DatosTrabajador.TrabajadorProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaTrabajador}
                                        setValue={setValue}
                                    //disabled={datosAPI?.ProvinciaCodigo ? true : false}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaTrabajador}
                                        watchCommunityCode={watchCommTrabajador}
                                        watchCommunityDescription={watchCommDescTrabajador}
                                        idCode={'DatosTrabajador.TrabajadorComunidadCodigo'}
                                        idDescription={'DatosTrabajador.TrabajadorComunidadCodigoDescripcion'}
                                        filterByProvince={true}
                                    //disabled={datosAPI?.LocalidadCodigo ? true : false}
                                    />
                                </div>
                            </FieldsetContainer>

                            <FieldsetContainer legend="Fecha, Hora, Descripción del Accidente" disabled={false}>
                                <FormInputFecha
                                    name={'DatosTrabajador.FechaAccidente'}
                                    id={'DatosTrabajador.FechaAccidente'}
                                    label={'Fecha de Nacimiento'}
                                    placeholder={''}
                                    md={6}
                                    xl={6}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                    disableDate={false}
                                />
                                <InputHora
                                    name={'DatosTrabajador.HoraAccidente'}
                                    id={'DatosTrabajador.HoraAccidente'}
                                    label={'Hora del Accidente'}
                                    placeholder={'HH:MM'}
                                    errors={errors}
                                    register={register}
                                    xl={6}
                                    md={6}
                                    col={12}
                                    disabled={false}
                                />
                                <TextAreaDefault
                                    name={'DatosTrabajador.DescripcionAccidente'}
                                    id={'DatosTrabajador.DescripcionAccidente'}
                                    label={'Descripción del Accidente'}
                                    req='El Accidente es Obligatorio'
                                    rows={5}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                {/* ////////////// CENTROS CONCERTADOS ////////////// */}
                <AccordionForm title={'Centros concertados'} expandedInit={false} nombreError='DatosCentroConcertado'>
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Espacio reservado para centros concertados" disabled={false}>
                                <FormInputText
                                    name='DatosCentroConcertado.NombreCentroConcertado'
                                    id='DatosCentroConcertado.NombreCentroConcertado'
                                    label='Nombre del Centro Concertado'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosCentroConcertado.TelefonoCentroConcertado'
                                    id='DatosCentroConcertado.TelefonoCentroConcertado'
                                    label='Teléfono del Centro Concertado'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                    pattern={/^\d{9}$/}
                                    patternMessage={'El Teléfono debe tener 9 dígitos'}
                                />
                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'DatosCentroConcertado.CentroConcertadoProvincia'}
                                        watchProvinceDescription={watchProvinciaDescCentroConcertado}
                                        idDescription={'DatosCentroConcertado.CentroConcertadoProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaCentroConcertado}
                                        setValue={setValue}
                                    //disabled={datosAPI?.ProvinciaCodigo ? true : false}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaCentroConcertado}
                                        watchCommunityCode={watchCommCentroConcertado}
                                        watchCommunityDescription={watchCommDescCentroConcertado}
                                        idCode={'DatosCentroConcertado.CentroConcertadoComunidadCodigo'}
                                        idDescription={'DatosCentroConcertado.CentroConcertadoComunidadCodigoDescripcion'}
                                        filterByProvince={true}
                                    //disabled={datosAPI?.LocalidadCodigo ? true : false}
                                    />
                                </div>
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>














                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <div className='mb-5' style={{ display: true ? 'block' : 'none' }}>
                    {/* ////////////// ACEPTACION DE LA DECLARACIÓN //////////// */}
                    <div className="row mb-4">
                        <div className="col-xl-12">

                            <FieldsetContainer legend="" disabled={false}>
                                <div className='paragraph mb-3 col-12'> Acepto la información declarada en el formulario y me hago responsable de los datos proporcionados. Esto continua siendo un texto de ejemplo no definitivo que se utilza en los formularios temporalmente
                                    {/** Acepto la información declarada */}
                                </div>
                                <div className='ml-5 form-check mb-4 col-12'>
                                    <input className='form-check-input' type='checkbox' id='Acepto' {...register('Acepto', { onChange: AceptarSolicitud })} />
                                    <label className='form-check-label ' htmlFor='Acepto'>Acepto la información declarada.</label>
                                </div>
                                <div className=' mb-4 col-12' style={{ display: aceptadoFormulario ? 'none' : 'block' }}>
                                    <div className='paragraph text-info col-12'>

                                        {datosAPI?.FechaAceptacionSolicitud ? "Aceptado el: " + new Intl.DateTimeFormat('es-ES', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit'
                                        }).format(new Date(datosAPI?.FechaAceptacionSolicitud ?? new Date()))
                                            :
                                            "Aceptado el: " + new Intl.DateTimeFormat('es-ES', { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date())
                                        }

                                    </div>
                                </div>
                            </FieldsetContainer>
                        </div>
                    </div>

                    {/* BOTON DE ENVIAR */}
                    <button className='btn-box btn-accent mt-3 mb-3' type="submit" disabled={aceptadoFormulario} onClick={handleSubmit(onSubmit)}>
                        {info ? "CREAR FORMULARIO" : "ACTUALIZAR FORMULARIO"}
                    </button>

                </div>













            </div>
        </FormProvider>
    )
}

export default SolicitudVolanteAsistencia
